var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dropzone-section", {
        ref: "dropzoneSection",
        on: {
          "added-file": _vm.handleAddDocument,
          "added-files": _vm.handleAddDocument,
          "removed-all-files": _vm.handleRemovedAllFiles,
        },
      }),
      _vm._v(" "),
      _c("upload-files-modal", {
        ref: "organize",
        attrs: {
          "application-id": _vm.applicationId,
          "client-username": _vm.clientUsername,
          uploading: _vm.uploading,
          "uploading-succeeded": _vm.uploadingSucceeded,
          "selected-files": _vm.selectedFiles,
          "selected-classification": _vm.selectedClassification,
          "allow-create": "",
        },
        on: {
          change: _vm.handleClassificationSelection,
          reset: _vm.resetData,
          submit: _vm.handleUploadDocuments,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }